import {
  CallActionPayload,
  MethodResponse,
  UIStateCallback,
} from 'components/ImpactAiDrawer/types';

import { ContextAPI } from '../../ImpactAiContextProvider';

import { executeInWebWorker } from './webWorkerExecutor';
import { validateScript } from './scriptValidator';

export const parseData = async (
  payload: CallActionPayload,
  contextApi: ContextAPI,
  uiStateCallback?: UIStateCallback
): Promise<MethodResponse> => {
  try {
    const { script, timeout = 5000 } = payload as { script: string; timeout?: number };

    if (!script) {
      return { error: new Error('Script is required') };
    }

    // Validate timeout
    if (typeof timeout !== 'number' || timeout < 100 || timeout > 30000) {
      return { error: new Error('Timeout must be a number between 100 and 30000 milliseconds') };
    }

    const validation = validateScript(script, {
      maxLength: 1000,
      maxLines: 50,
      allowAsync: true,
    });

    if (!validation.isValid) {
      return {
        error: new Error(`Script validation failed: ${validation.errors.join(', ')}`),
      };
    }

    if (validation.warnings.length > 0) {
      console.warn('Script validation warnings:', validation.warnings);
    }

    const context = contextApi.getFullContext();
    if (!uiStateCallback) {
      return { error: new Error('UI state callback is required for data parsing') };
    }

    const result = await executeInWebWorker(script, context, uiStateCallback, timeout);

    const resultString = JSON.stringify(result);
    // 1MB limit
    if (resultString.length > 1000000) {
      return { error: new Error('Parser result too large (>1MB)') };
    }

    return {
      contextUpdates: result,
    };
  } catch (error) {
    return {
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
};
